import SplitContent from 'Custom/Split/SplitContent';
import AjustableImage from 'Custom/AjustableImage';
import EFFECTIVE_IMAGE from 'Images/misc/effective.webp';
import EFFECTIVE_IMAGE_MOBILE from 'Images/misc/effective-mobile.webp';
import Button from 'Nori/Button';
import RichText from 'Custom/RichText';
import styles from 'Custom/EffectiveSplit/index.module.scss';

const EffectiveSplit = ({ color = 'default', moduleNumber = '01' }) => {
  return (
    <SplitContent
      backgroundColor={color}
      className={styles.fixWidth}
      data-qa-tag="home-effective-wrapper-split"
      reverse
      data-design-visible="visible_vd"
      data-design-type="module"
      data-design-nori_id="Inline Content"
      data-design-module_name="NEXPLANON is just as effective as the pill without the daily hassle"
      data-design-module_no={moduleNumber}
    >
      <AjustableImage
        data-qa-tag="home-effective-wrapper-image"
        size="full"
        specialImage={true}
        imageMobile={{
          src: EFFECTIVE_IMAGE_MOBILE,
          style: { width: 265, height: 181 },
          alt: 'Over 99% Effective: Less Than 1 Pregnancy per 100 Women Who Used NEXPLANON® (etonogestrel implant) 68 mg Radiopaque for 1 Year',
        }}
        image={{
          src: EFFECTIVE_IMAGE,
          style: { maxWidth: 432 },
          alt: 'Over 99% Effective: Less Than 1 Pregnancy per 100 Women Who Used NEXPLANON® (etonogestrel implant) 68 mg Radiopaque for 1 Year',
        }}
      />
      <>
        <RichText data-qa-tag="home-effective-content-wrapper">
          <h2 data-qa-tag="home-effective-title" className="mb">
            NEXPLANON is just as effective as the pill without the daily hassle
          </h2>
          <p className="body-text" data-qa-tag="home-effective-description">
            This is birth control you don’t have to take every day. NEXPLANON is
            a small, flexible implant that prevents pregnancy in women for up to
            5 years.<sup>†</sup> The study that extended NEXPLANON's use for up
            to 5 years included women of varying body weights.**
          </p>
          <p className="caption" data-qa-tag="home-effective-caption-1">
            <sup>†</sup>NEXPLANON must be removed by the end of the fifth year.
          </p>
          <p className="caption" data-qa-tag="home-effective-caption-2">
            **Women weighing more than 130% of their ideal body
            weight were not included in years 1-3 of clinical trials. In years
            4-5, women who had a body mass index ranging from 17.2 to 64.3 kg/m
            <sup>2</sup> were included.
          </p>
        </RichText>
        <Button
          data-qa-tag="home-effective-button"
          href="/effectiveness/"
          data-design-type="clickAction"
          data-design-category="button_vd"
          data-design-action="Button"
          data-design-label="Get the Details"
          data-design-nori_id="Inline Content"
          data-design-module_name="NEXPLANON is just as effective as the pill without the daily hassle"
          data-design-module_no={moduleNumber}
        >
          Get the Details
        </Button>
      </>
    </SplitContent>
  );
};

export default EffectiveSplit;
